import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/enjoy.png'


const _hoisted_1 = { class: "enjoy-area pt-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_5 = { class: "enjoy-content" }
const _hoisted_6 = { class: "row align-items-center mb-30" }
const _hoisted_7 = { class: "col-lg-8 col-sm-6" }
const _hoisted_8 = { class: "nestor-prepaid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "col-lg-6",
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": "100"
        }, [
          _createElementVNode("div", { class: "enjoy-img" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "enjoy"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "top-title" }, "استمتع", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("h2", null, "شاهد الرياضة، الأفلام، القنوات التلفزيونية والمزيد", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, " مع مجموعتنا الضخمة والشاملة من القنوات التلفزيونية، لن تفوتك أبداً مبارياتك الرياضية المفضلة وبرامجك التلفزيونية العربية والعالمية. ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("h4", null, "اشترك الآن واحصل على دعم فني احترافي ومباشر", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-4 col-sm-6" }, [
                _createElementVNode("div", { class: "starting-form mb-sm-0" }, [
                  _createElementVNode("span", null, "تبدأ من"),
                  _createElementVNode("h1", null, [
                    _createTextVNode("$ 49.99"),
                    _createElementVNode("sub", null, "/ شهرياً")
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "باقات IPTV المميزة", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("h3", null, "اختر الباقة التي تناسب احتياجاتك الترفيهية", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/about-us",
                    class: "read-more style-two text-grey-teal"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" اعرف المزيد ", -1),
                      _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_RouterLink, {
              to: "/pricing-plan",
              class: "btn bg-grey-teal"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "border-style" }, "عرض جميع باقات الاشتراك", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}